import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HomeIfcFile } from 'situview-webapi-client';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ICompany } from 'identity-webapi-client';
import { ConfigService } from 'src/app/services/config.service';

import "@google/model-viewer/dist/model-viewer";

@Component({
  selector: 'artifact-viewer-dialog',
  templateUrl: './artifact-viewer-dialog.component.html',
  styleUrls: ['./artifact-viewer-dialog.component.scss']
})
export class ArtifactViewerDialogComponent implements AfterViewInit {
  fileType: string | undefined;
  url: string | undefined;
  urlIos: string | undefined;
  posterUrl: string | undefined;

  productWidth: number = 150;
  productHeight: number = 150;
  @ViewChild('modelContainer') modelContainer: ElementRef | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ArtifactViewerDialogData,
    private dialogRef: MatDialogRef<ArtifactViewerDialogData>,
    private snackBar: MatSnackBar,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef) {
      if (data?.fileName) {
        if (data.fileName.endsWith(".jpg") || data.fileName.endsWith(".jpeg")) {
          this.fileType = ".jpg";
          this.url = `${this.configService.config.situViewWebApiBaseUrl}/home/getimage?artifactid=${data.artifactId}&filename=${data.fileName}`;
        }
        else if (data.fileName.endsWith(".webp")) {
          this.fileType = ".webp";
          this.url = `${this.configService.config.situViewWebApiBaseUrl}/home/getimage?artifactid=${data.artifactId}&filename=${data.fileName}`;
        } 
        else if (data.fileName.endsWith(".png")) {
          this.fileType = ".png";
          this.url = `${this.configService.config.situViewWebApiBaseUrl}/home/getimage?artifactid=${data.artifactId}&filename=${data.fileName}`;
        } 
        else if (data.fileName.endsWith(".glb")) {
          this.fileType = ".glb";
          this.url = `${this.configService.config.situViewWebApiBaseUrl}/home/getglb?artifactid=${data.artifactId}&filename=${data.fileName}`;
          this.urlIos = `${this.configService.config.situViewWebApiBaseUrl}/home/getglb?artifactId=${data.artifactId}&fileName=product.usdz`;
          this.posterUrl = `${this.configService.config.situViewWebApiBaseUrl}/home/getimage?artifactid=${data.artifactId}&filename=preview.webp`;
        }
      }
  }
  ngAfterViewInit(): void {
    this.resizeModelViewer();
  }

  exposureValue = 0.5;
  shadowIntensityValue = 1;
  onExposureChange(event: any) {
    this.exposureValue = event.value;
  }
  onShadowIntensityChange(event: any) {
    this.shadowIntensityValue = event.value;
  }
  private resizeModelViewer() {
    if (this.modelContainer) {
      const parentWidth = this.modelContainer.nativeElement.offsetWidth;
      const parentHeight = this.modelContainer.nativeElement.offsetHeight;
  
      // Set the model-viewer size
      this.productWidth = parentWidth * 0.9;
      this.productHeight = parentHeight * 0.9;
      this.cdr.detectChanges(); // Trigger change detection manually
    }
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }
}

export interface ArtifactViewerDialogData {
  fileName: string | undefined;
  artifactId: string | undefined;
}
